import { HistoryMessageItem, MessageIncomingEvent, MessageOutgoingEvent } from '@wui/im'

import { useStoreRooms } from '@/app/store/pinia/rooms/rooms'

import { useStoreContacts } from '@/entities/contact'

import { useCurrentUser } from '@/shared/composables/current-user'
import { useLocalization } from '@/shared/composables/localization'
import { getUnknownContactLabel } from '@/shared/utils/contacts'
import { isGuest } from '@/shared/utils/uri'

export const getForwardingAuthorName = (
  event: HistoryMessageItem<MessageIncomingEvent | MessageOutgoingEvent>,
): string => {
  const { t } = useLocalization()
  const { currentUser } = useCurrentUser()
  const { findByPServed } = useStoreContacts()
  const { findGuestByPserved } = useStoreRooms()

  const executor = event.item.executor
  const contact = findByPServed(executor)

  if (contact?.name) {
    return contact.name
  }

  if (isGuest(executor)) {
    const guestName = findGuestByPserved(event.item.pServed, executor)
    return guestName ? `${guestName} (${t('common.guest')})` : t('common.guest')
  }

  if (event.item.type === 'OutgoingMessageEvent' || currentUser.value?.imLogin === executor) {
    return currentUser.value?.name ?? t('common.externalContact')
  }

  if (executor) {
    return getUnknownContactLabel(executor)
  }

  return t('common.externalContact')
}
